import React, { PureComponent } from 'react';
// utils
import T from 'prop-types';
import isEmpty from 'lodash.isempty';
// shapes
import inputStep from '../../../shapes/inputStep';
// components
import RadioGroup from '../../../components/RadioGroup/RadioGroup';
import FieldError from '../../../components/Form/FieldError';

class RadioGroupInput extends PureComponent {
  handleChange = event => {
    const {
      data: {
        content: { questions }
      },
      setFieldValue
    } = this.props;

    questions.map(({ id }) => setFieldValue(id, false));
    setFieldValue(event.target.value, true);
  };

  getOptions = () => {
    const {
      data: { content }
    } = this.props;
    return content.questions.map(({ title, id }) => ({
      value: id,
      label: title
    }));
  };

  getError = () => {
    const { errors } = this.props;
    const options = this.getOptions();
    const hasError =
      !isEmpty(errors) &&
      options.find(({ value }) => errors.hasOwnProperty(value));

    return hasError ? 'The answer must be selected!' : '';
  };

  render() {
    const {
      data: {
        content: { id, questions }
      },
      values
    } = this.props;
    const options = this.getOptions();
    const error = this.getError();
    const value = questions.find(({ id }) => values[id] === true);
    return (
      <div>
        <RadioGroup
          vertical
          name={id}
          options={options}
          value={value && value.id}
          onChange={this.handleChange}
        />
        <FieldError error={error} touched={true} />
      </div>
    );
  }
}

RadioGroupInput.propTypes = {
  data: inputStep,
  setFieldValue: T.func.isRequired,
  values: T.object.isRequired,
  errors: T.object.isRequired
};

export default RadioGroupInput;



// WEBPACK FOOTER //
// ./src/containers/Module/components/RadioGroupInput.jsx